import React, { useState } from 'react';
import { Box, TextField, Typography, Button, Paper, CircularProgress, Alert } from '@mui/material';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/admin/send-magic-link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed');
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fafafa' }}>
      <Paper elevation={0} sx={{ width: 400, p: 5, borderRadius: 3, border: '1px solid #eee' }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a2e', mb: 0.5 }}>Admin Portal</Typography>
        <Typography variant="body2" sx={{ color: '#888', mb: 4 }}>Sign in with your magic link</Typography>

        {sent ? (
          <Alert severity="success" sx={{ borderRadius: 2 }}>
            Check your email — we sent a sign-in link to <strong>{email}</strong>. It expires in 5 minutes.
          </Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}
            <TextField
              fullWidth
              label="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              sx={{ mb: 3 }}
              size="small"
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                bgcolor: '#1a1a2e',
                color: '#fff',
                py: 1.3,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': { bgcolor: '#2a2a4e' },
              }}
            >
              {loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Send Magic Link'}
            </Button>
          </form>
        )}
      </Paper>
    </Box>
  );
}
